"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8 8-3.5817 8-8-3.5817-8-8-8zM2 12C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10 0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10z"
  }), _react.default.createElement("path", {
    d: "M11.4177 8.228c.5275-.433 1.3055-.3593 1.7423.1649.4591.5509.3576 1.375-.2213 1.798l-.8634.631A2.6225 2.6225 0 0 0 11 12.9394v.676h2v-.676c0-.5375.7494-.8639 1.1187-1.1337 1.5112-1.1043 1.776-3.2553.5778-4.6932-1.1403-1.3683-3.171-1.5605-4.5477-.4303L8.8235 7.77l1.269 1.5459 1.3252-1.0879zm1.8323 8.0298c0 .6904-.5596 1.25-1.25 1.25s-1.25-.5596-1.25-1.25c0-.6903.5596-1.25 1.25-1.25s1.25.5597 1.25 1.25z"
  })];
};

exports.default = _default;